const MANDATORY_SCHEMA_FIELDS = new Set([
    'customers.clientname',
    'customers.companyname',
    'customers.identitynumber',
    'customers.taxnumber',
    'customers.reference',
    'customers.phones.phonedescription',
    'customers.phones.phone',
    'customers.contractrate',
    'customers.enforcementattorneyfeesharerate',
    'customers.judgmentattorneyfeesharerate',
    'customers.payinteresttocustomer',
    'licenseplates.licenseplatenumber',
    'licenseplates.isthereopendamagefile',
    'accidents.accidentdate',
    'accidents.ourfaultrate',
    'accidents.documentrequestdate',
    'accidents.documentrequeststatus',
    'accidents.documentreceiveddate',
    'accidents.counterpartylicenseplatenumber',
    'accidents.counterpartytrafficinsurancepolicy',
    'accidents.counterpartytrafficinsurancepolicy.trafficinsuranceprovider',
    'accidents.counterpartytrafficinsurancepolicy.trafficinsurancenumber',
    'accidents.counterpartytrafficinsurancepolicy.trafficinsurancestart',
    'accidents.counterpartytrafficinsurancepolicy.trafficinsuranceexpiry',
    'powersofattorney.poadate',
    'powersofattorney.ispoatimelimited',
    'powersofattorney.islicenseplateslimited',
    'powersofattorney.poaoriginalarrived',
    'accidentfile.isthereopendamagefile',
    'accidentfile.whoseinsurance',
    'accidentfile.filestobeworked.filetype',
    'accidentfile.filestobeworked.fileexpense',
    'accidentfile.filestobeworked.withreport',
    'accidentfile.filestobeworked.withfault',
    'accidentfile.filestobeworked.withoutreport',
]);

const FIELD_ALIASES = {
    'customer.clientname': 'customers.clientname',
    'customer.companyname': 'customers.companyname',
    'customer.identitynumber': 'customers.identitynumber',
    'customer.taxnumber': 'customers.taxnumber',
    'customer.reference': 'customers.reference',
    'customer.phones.phonedescription': 'customers.phones.phonedescription',
    'customer.phones.phone': 'customers.phones.phone',
    'customer.contractrate': 'customers.contractrate',
    'customer.enforcementattorneyfeesharerate': 'customers.enforcementattorneyfeesharerate',
    'customer.judgmentattorneyfeesharerate': 'customers.judgmentattorneyfeesharerate',
    'customer.payinteresttocustomer': 'customers.payinteresttocustomer',
    'licenseplate.licenseplatenumber': 'licenseplates.licenseplatenumber',
    'licenseplate.isthereopendamagefile': 'licenseplates.isthereopendamagefile',
    'accident.accidentdate': 'accidents.accidentdate',
    'accident.ourfaultrate': 'accidents.ourfaultrate',
    'accident.documentrequestdate': 'accidents.documentrequestdate',
    'accident.documentrequeststatus': 'accidents.documentrequeststatus',
    'accident.documentreceiveddate': 'accidents.documentreceiveddate',
    'accident.counterpartylicenseplatenumber': 'accidents.counterpartylicenseplatenumber',
    'accident.counterpartytrafficinsurancepolicy': 'accidents.counterpartytrafficinsurancepolicy',
    'accident.counterpartytrafficinsurancepolicy.trafficinsuranceprovider': 'accidents.counterpartytrafficinsurancepolicy.trafficinsuranceprovider',
    'accident.counterpartytrafficinsurancepolicy.trafficinsurancenumber': 'accidents.counterpartytrafficinsurancepolicy.trafficinsurancenumber',
    'accident.counterpartytrafficinsurancepolicy.trafficinsurancestart': 'accidents.counterpartytrafficinsurancepolicy.trafficinsurancestart',
    'accident.counterpartytrafficinsurancepolicy.trafficinsuranceexpiry': 'accidents.counterpartytrafficinsurancepolicy.trafficinsuranceexpiry',
    'powerofattorney.poadate': 'powersofattorney.poadate',
    'powerofattorney.ispoatimelimited': 'powersofattorney.ispoatimelimited',
    'powerofattorney.islicenseplateslimited': 'powersofattorney.islicenseplateslimited',
    'powerofattorney.poaoriginalarrived': 'powersofattorney.poaoriginalarrived',
    'accidentfiles.isthereopendamagefile': 'accidentfile.isthereopendamagefile',
    'accidentfiles.whoseinsurance': 'accidentfile.whoseinsurance',
    'accidentfiles.filestobeworked.filetype': 'accidentfile.filestobeworked.filetype',
    'accidentfiles.filestobeworked.fileexpense': 'accidentfile.filestobeworked.fileexpense',
    'accidentfiles.filestobeworked.withreport': 'accidentfile.filestobeworked.withreport',
    'accidentfiles.filestobeworked.withfault': 'accidentfile.filestobeworked.withfault',
    'accidentfiles.filestobeworked.withoutreport': 'accidentfile.filestobeworked.withoutreport',
};

const normalizeFieldName = (fieldName) => {
    const target = String(fieldName || '').toLowerCase();
    return FIELD_ALIASES[target] || target;
};

export const isMandatorySchemaField = (fieldName) => MANDATORY_SCHEMA_FIELDS.has(normalizeFieldName(fieldName));

export const getFieldAccess = (fieldPermissions, fieldName, canEdit = true) => {
    // Default: ReadOnly if canEdit is false or permission missing
    if (!canEdit) {
        return {
            disabled: true,
            editable: false,
            required: false,
        };
    }

    const safePermissions = Array.isArray(fieldPermissions) ? fieldPermissions : [];

    // canEdit true ama durum için hiç alan izni tanımlı değilse, tüm alanları düzenlenebilir yap
    if (safePermissions.length === 0) {
        return {
            disabled: false,
            editable: true,
            required: isMandatorySchemaField(fieldName),
        };
    }

    const target = String(fieldName || '').toLowerCase();
    const permission = safePermissions.find((p) => String(p?.fieldName || '').toLowerCase() === target);

    const editable = permission
        ? (typeof permission.editable === 'boolean'
            ? permission.editable
            : String(permission.access || '').toLowerCase() === 'editable')
        : false; // Missing permission => ReadOnly

    return {
        disabled: !editable,
        editable,
        required: editable && isMandatorySchemaField(fieldName),
    };
};
